import { Routes } from "@angular/router";
import { authGuard } from "./guards/auth.guard";

// Direct imports - no lazy loading
import { LoginComponent } from "./components/login/login.component";
import { ChatComponent } from "./components/chat/chat.component";
import { DatasetsComponent } from "./components/datasets/datasets.component";
import { PublicChat } from "./components/public-chat/public-chat";
import { LandingComponent } from "./components/landing/landing.component";

export const routes: Routes = [
  {
    path: "",
    component: LandingComponent
  },
  {
    path: "login",
    component: LoginComponent,
  },
  {
    path: "chat",
    component: ChatComponent,
    canActivate: [authGuard],
  },
  {
    path: "datasets",
    component: DatasetsComponent,
    canActivate: [authGuard],
  },
  {
    path: ":datasetId",
    component: PublicChat,
  },
];
